module.exports = __webpack_public_path__ + "static/media/fighter-jet.3544f5c4.svg";